import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApDynComponentComponent}                                from '../../ap-dyncomponent/ap-dyncomponent.component';
import {
  ApDynGridColumnConfigBase
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {Observable, Subscription}                               from 'rxjs';
import {
  ApDynGridPagerConfigBase
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-pager-config-base';
import {IPpPlanningBookingGridItem}                             from '../types/pp-planning-booking.types';
import {ApUtilService}                                          from '../../ap-utils/service/ap-util.service';
import {PpPlanningBookingGridConfig}                            from '../configs/pp-planning-booking-grid.config';
import {PpPlanningBookingDataService}                           from '../services/pp-planning-booking-data.service';
import {
  PpPlanBookingComponent
}                                                               from '../../entry-components/plant-protection-entry-components/pp-plan-booking.component';
import {FormStore}                                              from '../../stores/layout/form.store';
import {
  DropDownButtonData
}                                                               from '../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {LoginStore}                                             from '../../stores/login/login.store';
import {ApRoleTypeService}                                      from '../../services/common/ap-role-type.service';
import {
  PpPlanBookingShowComponent
}                                                               from '../../entry-components/plant-protection-entry-components/pp-plan-booking-show.component';

@Component({
  selector: 'plant-protection-booking',
  template: `
    <ap-dyncomponent [caption]="'Global__Booking'"
                     [items]="items$ | async"
                     [loading$]="loading$"
                     [headerIcon]="'ap-fungidetect-icon'"
                     [pager]="pager"
                     [columns]="columns"
                     [selectable]="{ checkboxOnly: false, mode: 'single' }"
                     [canSearch]="true"
                     [canCreate]="false">
    </ap-dyncomponent>
  `,
  styles: []
})
export class PpBookingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent) dynComponent: ApDynComponentComponent;
  public columns: ApDynGridColumnConfigBase[] = [];
  public items$: Observable<IPpPlanningBookingGridItem[]>;
  public loading$: Observable<boolean>;
  public pager: ApDynGridPagerConfigBase;

  private _subscriptions: Subscription[] = [];

  constructor(private formStore: FormStore,
              private loginStore: LoginStore,
              private roleTypeService: ApRoleTypeService,
              private dataService: PpPlanningBookingDataService,
              private gridConfig: PpPlanningBookingGridConfig) {
  }

  public ngOnInit(): void {
    this.dataService.init(true);
    this.loading$ = this.dataService.getLoading$();
    this.items$ = this.dataService.buildDataItems();
    this.dataService.subscribeLoad();
    this._buildGrid();
  }

  public ngAfterViewInit(): void {
    this.dataService.subscribeSelection(this.dynComponent);
  }

  public ngOnDestroy(): void {
    this.dataService.destroy();
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  private _buildGrid(): void {
    const dropDownActions: DropDownButtonData[] = [
      {
        text: 'Global__Show',
        callback: ApUtilService.createEventEmitter(this._onShow.bind(this), this._subscriptions),
        disabled: false
      },
      {
        text: 'Global__Reset',
        callback: ApUtilService.createEventEmitter(this._onReset.bind(this), this._subscriptions),
        disabled: false
      },
      {
        text: 'Global__Export',
        callback: ApUtilService.createEventEmitter(this._onExport.bind(this), this._subscriptions),
        disabled: true
      }
    ];

    this.columns = this.gridConfig.getGridColumns(dropDownActions);
    this.pager = this.gridConfig.getGridPager([
      {
        text: 'Global__Show',
        callback: ApUtilService.createEventEmitter(this._pagerOnShow.bind(this), this._subscriptions),
      },
      {
        text: 'Global__Reset',
        callback: ApUtilService.createEventEmitter(this._pagerOnReset.bind(this), this._subscriptions),
      },
      {
        text: 'Global__Export',
        callback: ApUtilService.createEventEmitter(this._pagerOnExport.bind(this), this._subscriptions)
      }
    ]);
  }

  private _pagerOnShow(): void {
    const selectedItem = this._getSelectedItem();
    if (selectedItem) {
      this._onShow(selectedItem);
    }
  }

  private _pagerOnReset(): void {
    const selectedItem = this._getSelectedItem();
    if (selectedItem) {
      this._onReset(selectedItem);
    }
  }

  private _pagerOnExport(): void {
    const selectedItem = this._getSelectedItem();
    if (selectedItem) {
      this._onExport(selectedItem);
    }
  }

  private _getSelectedItem(): IPpPlanningBookingGridItem | null {
    const selectedItems = this.dynComponent.getSelectedItems() as IPpPlanningBookingGridItem[];
    if (!selectedItems || selectedItems.length <= 0) {
      return null;
    }
    return selectedItems[0];
  }

  private _onReset(dataItem: IPpPlanningBookingGridItem): void {
    if (!dataItem.PlanBooks || dataItem.PlanBooks.length <= 0) {
      return;
    }
    this.formStore.openForm({
      component: PpPlanBookingComponent,
      data: {
        DataItem: dataItem.PlanBooks,
        IsBooked: true
      }
    });
  }

  private _onShow(dataItem: IPpPlanningBookingGridItem): void {
    if (!dataItem.PlanBooks || dataItem.PlanBooks.length <= 0) {
      return;
    }
    this.formStore.openForm({
      component: PpPlanBookingShowComponent,
      data: {
        DataItem: dataItem.PlanBooks
      }
    });
  }

  private _onExport(dataItem: IPpPlanningBookingGridItem): void {
    console.log(dataItem);
    console.warn('Method not implemented.');
  }
}
